import Utils from "../../Shared/Utils";
import NetworkLogic from "../../Shared/NetworkLogic";
import {Global} from "../../Shared/Global";
import UIManager from "../../Shared/UIManager";
import find = cc.find;
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class XiMaBiLi extends cc.Component {
    @property(cc.Node)
    ratDetail: cc.Node = null;
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.ToggleContainer)
    togContent: cc.ToggleContainer = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    content: cc.Node = null;

    data = [];
    childDataArr = [];
    private tempPlatformGameType: number = 0;
    infoDtos = null;

    onLoad () {
        //this.node.on(Global.UserEvent.XimaGameDetail,this.setData.bind(this));

    }

    async start() {
        //UIManager.showLoadingUI();
        // NetworkLogic.ximaWashCodeDetail({},function (rec) {
        //     UIManager.hideLoadingUI();
        //     cc.log("========ximaInfo rec:",rec);
        //     this.updateUI(rec)
        // }.bind(this),function () {
        //     UIManager.hideLoadingUI();
        // }.bind(this));

        // NetworkLogic.ximaGameList({},function (rec) {
        //     UIManager.hideLoadingUI();
        //     cc.log("========ximaInfo rec:",rec);
        //     this.updateUI(rec)
        // }.bind(this),function () {
        //     UIManager.hideLoadingUI();
        // }.bind(this));

        if (!this.infoDtos) {
            this.infoDtos = await this.getInfo();
        }
        this.infoDtos && this.updateUI(this.infoDtos)

    }

    getInfo():Promise<any>{
        return new Promise<any>(resolve => {
            UIManager.showLoadingUI();
            NetworkLogic.ximaInfo(function (data) {
                UIManager.hideLoadingUI();
                let info = data.washCodeTypeInfoDtos;
                resolve(info)
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                console.log("rich=== ximaZZXM请求失败")
                resolve(null)
            })
        })
    }




    //获取总分类
    updateUI(rec){
        this.data = [];
        let items = this.togContent.toggleItems;
        for (let i = 0; i < rec.length;i++){//
            let tempData = {
                gameTypeName:"",
                platformGameType:0,
                childGameList:[]
            };

            let typeId = rec[i].gameTypeId;
            if (typeId === 2){//体育里面有电子竞技，单独列出来；
                let list = rec[i].gameInfoLists;
                tempData.gameTypeName = rec[i].gameTypeName;
                let tempData1 = {
                    gameTypeName:"电竞游戏",
                    platformGameType:3,
                    childGameList:[]
                };
                for (let j = 0;j < list.length;j++){
                    if (list[j].gameTypeId === 6){
                        tempData.platformGameType = list[j].gameTypeId;
                        tempData.childGameList.push({
                            gameName:list[j].gameName,
                            platformGameType:list[j].gameTypeId,
                            platform:list[j].platform
                        });
                    }else{
                        tempData1.platformGameType = list[j].gameTypeId;
                        tempData1.childGameList.push({
                            gameName:list[j].gameName,
                            platformGameType:list[j].gameTypeId,
                            platform:list[j].platform
                        });
                    }
                }
                this.data.push(tempData1);
            } else{
                let list = rec[i].gameInfoLists;
                tempData.gameTypeName = rec[i].gameTypeName;
                for (let j = 0;j < list.length;j++){

                    tempData.platformGameType = list[j].gameTypeId;
                    tempData.childGameList.push({
                        gameName:list[j].gameName,
                        platformGameType:list[j].gameTypeId,
                        platform:list[j].platform,
                        id:list[j].id

                    });
                }
            }
            this.data.push(tempData);
        }

        for (let i = 0;i < this.data.length;i++){//给toggle标题赋值
            items[i].node.getChildByName("New Label").getComponent(cc.Label).string = this.data[i].gameTypeName;
            items[i].checkEvents[0].customEventData = this.data[i].platformGameType;
        }
        this.onToggleSlicked(null,this.data[0].platformGameType);
    }

    //点击详情按钮
    onBtnDetails(event,param){
        AudioManager.playSound("button");
        this.ratDetail.active = true;
        let data = this.childDataArr[this.tempPlatformGameType][parseInt(param)].rec;
        this.ratDetail.getComponent("RatDetails").updateUI(data);
    }

    async onToggleSlicked(event, param) {//选择标题
        AudioManager.playSound("toggle");
        this.tempPlatformGameType = parseInt(param);
        let childGameList = null;
        for (let i = 0; i < this.data.length; i++) {//找到子栏目
            if (this.data[i].platformGameType === parseInt(param)) {
                childGameList = this.data[i].childGameList;
                break;
            }
        }
        let recArr = [];
        if (!this.childDataArr[parseInt(param)]){
            let data1 = {
                "platformGameType": param,
            };
            let rec = await this.getRec(data1);
            if (param == 2){//捕鱼通过id 判断
                for (let i = 0; i < childGameList.length; i++) {//获取子栏目数据
                    recArr.push({
                        gameName:childGameList[i].gameName,
                        rec:rec[childGameList[i].id]
                    });
                }
            }else{
                for (let i = 0; i < childGameList.length; i++) {//获取子栏目数据
                    recArr.push({
                        gameName:childGameList[i].gameName,
                        rec:rec[childGameList[i].platform]
                    });
                }
            }
            this.childDataArr[parseInt(param)] = recArr;
        }
        else{
            recArr = this.childDataArr[parseInt(param)];
        }
        this.showItem(recArr);
    }

    //显示子栏目
    showItem(recArr){
        if (this.content.children.length > recArr.length){
            for (let i = recArr.length;i < this.content.children.length;i++){
                this.content.children[i].active = false;
            }
        }
        let item = null;
        for (let i = 0;i < recArr.length;i++){
            if (i  < this.content.children.length){
                item = this.content.children[i];
            }else {
                item = cc.instantiate(this.item);
            }
            item.parent = this.content;
            item.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i%2 === 0 ? this.sp1 : this.sp2);
            item.getChildByName("labName").getComponent(cc.Label).string = recArr[i].gameName;
            item.getChildByName("labSum").getComponent(cc.Label).string = this.getSum(recArr[i].rec)[0].toString();
            item.getChildByName("labRat").getComponent(cc.Label).string = this.getSum(recArr[i].rec)[1].toString();
            item.getChildByName("btn").getComponent(cc.Button).clickEvents[0].customEventData = i.toString();
            item.active = true;
        }
    }
    // 获取最大最小值
    getSum(rec){
        let maxCode = 0;
        let minCode = 0;
        let max = 0;
        let min = 0;
        for (let key in rec){
            let childData = rec[key];

            for (let i = 0;i < childData.length;i++){
                max = childData[0].wcPercent;
                min = childData[0].wcPercent;
                let codeArr = childData[i].wcMoneyScope.split(",");
                minCode = codeArr[0];
                maxCode = codeArr[1];

                break;
            }
            break;
        }
        for (let key in rec){
            let childData = rec[key];
            for (let i = 0;i < childData.length;i++){
                let codeArr = childData[i].wcMoneyScope.split(",");
                let tempMinCode = parseInt(codeArr[0]);
                let tempMaxCode = parseInt(codeArr[1]);
                minCode = (tempMinCode < minCode ? tempMinCode : minCode);
                maxCode = (tempMaxCode > maxCode ? tempMaxCode : maxCode);
            }
            for (let i = 0;i < childData.length;i++){
                if (max <= childData[i].wcPercent){
                    max = childData[i].wcPercent;
                }
                if (min >= childData[i].wcPercent){
                    min = childData[i].wcPercent;
                }
            }
        }
        return [minCode + "-" + maxCode,min + "%" + "-" + max + "%"];
    }

    //获取详情数据
    getRec(data1):Promise<any>{
        UIManager.showLoadingUI();
        return  new Promise<any>((resolve)=>{
                NetworkLogic.ximaVippercentset(data1,function (rec) {
                    cc.log("===getRat rec:",rec);
                    UIManager.hideLoadingUI();
                    resolve(rec)
                }.bind(this),function () {
                    UIManager.hideLoadingUI();
                    resolve(null)
                }.bind(this));
            }
        )
    }



    onDestroy(): void {
        //this.node.off(Global.UserEvent.XimaGameDetail);
    }
}
